import axiosInstance from '../api/axiosInstance'
import { FLEXY_PRODUCTS_MULTIPLE_PATH } from '../constants/productsApiPaths'
import { mapApiProductToOrderDetails } from './productStockDisplayUtils'

function authHeaders() {
  const token = localStorage.getItem('accessToken')
  return { Authorization: `Bearer ${token}` }
}

function storeProduct(details: Record<string, any>, product: any, fallbackSku?: string) {
  const sku = product?.sku?.toString().replace(/^0+/, '') || fallbackSku || ''
  const mapped = mapApiProductToOrderDetails({ ...product, sku })
  if (sku) details[sku] = mapped
  if (fallbackSku && fallbackSku !== sku) details[fallbackSku] = mapped
  const rawId = product?.product_id != null ? String(product.product_id) : ''
  if (rawId) details[rawId] = mapped
}

export async function fetchMappedProductsBySkus(skus: string[]): Promise<Record<string, any>> {
  const unique = Array.from(new Set(skus.map(sku => String(sku || '').trim()).filter(Boolean)))
  const details: Record<string, any> = {}
  if (!unique.length) return details

  try {
    const response = await axiosInstance.get(
      `${FLEXY_PRODUCTS_MULTIPLE_PATH}?skus=${unique.join(',')}`,
      { headers: authHeaders() }
    )
    const products = response.data?.products
    if (Array.isArray(products)) {
      products.forEach((product: any) => storeProduct(details, product))
    }
  } catch (error) {
    console.error('Error al cargar productos múltiples:', error)
  }

  const missing = unique.filter(sku => !details[sku] && !details[sku.replace(/^0+/, '')])
  for (const sku of missing) {
    try {
      const response = await axiosInstance.get(`/products/${sku}`, { headers: authHeaders() })
      if (response.data) storeProduct(details, response.data, sku)
    } catch (error) {
      console.error('Error al cargar producto:', sku, error)
    }
  }

  return details
}
